.card {
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-card);
}

.title {
  padding: 14px 20px 6px;
  font-size: 17px;
}

.empty {
  padding: 14px 20px;
  border-top: 1.5px solid var(--ink);
  color: var(--ink-2);
}
